import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsRestoreRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-restore',
	path: '/secure/RestoreDefaultDashboard([!%]?[\\w]*).jspa',
};
